import React from 'react';
import './index.scss';

export default function EmptyPlaceHolder(props) {
  const { text = '暂无内容' } = props;
  return (
    <div className="empty-place-holder">
      <i className="place-holder-icon" />
      <span className="empty-desc">{text}</span>
    </div>
  )
}